import AudioPlayer from '@commons/components/AudioPlayer';
import { asAbsoluteURL } from '@commons/helpers/url';
import type { DrupalBlock } from '@commons/types/drupal';

// Type definition for the AudioBlock component properties.

type Props = DrupalBlock<{
  url: string;
}>;

/**
 * Audio block component.
 */

const AudioBlock = ({ content }: Props) => {
  if (!content?.url) return null;

  const url = asAbsoluteURL(content.url);

  return <AudioPlayer autoPlay={false} controls={true} src={url} />;
};

export default AudioBlock;
